import SwipeableRow from './SwipeableRow';

/**
 * SwipeablePinnableRow — SwipeableRow + position wrapper + pin badge in one.
 *
 * Props:
 *   pinned   — show 📌 badge when true
 *   actions  — passed through to SwipeableRow
 *   disabled — passed through to SwipeableRow
 *   children — the card content
 */
export default function SwipeablePinnableRow({ pinned, actions, disabled, children }) {
  return (
    <SwipeableRow actions={actions} disabled={disabled}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {pinned && (
          <span style={{
            flexShrink: 0,
            fontSize: '0.8rem', pointerEvents: 'none', lineHeight: 1,
            paddingLeft: '4px', paddingRight: '2px',
          }}>📌</span>
        )}
        <div style={{ flex: 1, minWidth: 0 }}>{children}</div>
      </div>
    </SwipeableRow>
  );
}
